var app = angular.module('directives.localization');
app.directive('localization', localization);

function localization() {
    var directive = {
        restrict: 'A',
        scope: {
            tmpl: '@'
        },

        link: function(scope, $scope){
            $scope.tmpl = scope.tmpl || '';
        },

        template: require('../templates/localization.html'),
        controller: ['$scope', 'Localization', Cntrl]
    };

    function Cntrl($scope, Localization) {
        $scope.lang = Localization;
        $scope.uniqueId = 'language-page-' + Math.random().toString(36).substr(2, 9);
    }

    return directive;
}

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/localization/directives/localization.directive.js
 ** module id = 170
 ** module chunks = 1
 **/